export default __webpack_public_path__ + "static/media/balance.a1279272.svg";